export class UIAppState {
    static isAppRunningOnBackground: boolean = false

    static startTracking() {
        document.addEventListener('visibilitychange', () => {
            UIAppState.isAppRunningOnBackground = document.visibilityState == 'hidden'
        })
    }
}
